let clickAudioContext = null

export function playUiClick() {
  if (typeof window === "undefined") return

  const AudioContextClass = window.AudioContext || window.webkitAudioContext
  if (!AudioContextClass) return

  try {
    clickAudioContext ||= new AudioContextClass()
    const now = clickAudioContext.currentTime
    const oscillator = clickAudioContext.createOscillator()
    const gain = clickAudioContext.createGain()

    oscillator.type = "sine"
    oscillator.frequency.setValueAtTime(760, now)
    oscillator.frequency.exponentialRampToValueAtTime(420, now + 0.035)
    gain.gain.setValueAtTime(0.0001, now)
    gain.gain.exponentialRampToValueAtTime(0.055, now + 0.004)
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.045)
    oscillator.connect(gain)
    gain.connect(clickAudioContext.destination)
    oscillator.start(now)
    oscillator.stop(now + 0.05)
  } catch {
    // Sound is progressive enhancement; navigation and copying must never
    // depend on an available or resumed Web Audio context.
  }
}
